import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import "../EmployeeSection/Employeepercentage.css";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import authAxios from "../Auth/useAxios";
import Swal from "sweetalert2";
import { ADMIN_API_BASE_URL } from "../Auth/Api";

const Employeepercentage = () => {
  const [formData, setFormData] = useState({
    name: "",
    gmPercentage: "",
    agmPercentage: "",
    dmPercentage: "",
    doPercentage: "",
    moPercentage: "",
  });

  const [errors, setErrors] = useState({});
  const [savedSections, setSavedSections] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    const savedData = localStorage.getItem("savedSections");
    if (savedData) {
      setSavedSections(JSON.parse(savedData));
    }
  }, []);

  useEffect(() => {
    fetchPercentageHistory();
  }, [savedSections]);

  const fetchPercentageHistory = async () => {
    const response = await authAxios.get(
      `${ADMIN_API_BASE_URL}/main/admin/get-all-incentives`
    );
    const data = response;
    setSavedSections(response.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Section name is required";

    if (String(formData.gmPercentage).trim() === "")
      newErrors.gmPercentage = "General Manager percentage is required";

    if (String(formData.agmPercentage).trim() === "")
      newErrors.agmPercentage = "AGM percentage is required";

    if (String(formData.dmPercentage).trim() === "")
      newErrors.dmPercentage = "Development Manager percentage is required";

    if (String(formData.doPercentage).trim() === "")
      newErrors.doPercentage = "Development Officer percentage is required";

    if (String(formData.moPercentage).trim() === "")
      newErrors.moPercentage = "Marketing Officer percentage is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      let response;
      if (editIndex !== null) {
        response = await authAxios.put(
          `${ADMIN_API_BASE_URL}/main/admin/update-incentive/${savedSections[editIndex].id}`,
          formData,
          { headers: { "Content-Type": "application/json" } }
        );
      } else {
        response = await authAxios.post(
          `${ADMIN_API_BASE_URL}/main/admin/add-incentives`,
          formData,
          { headers: { "Content-Type": "application/json" } }
        );
      }

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text:
            editIndex !== null
              ? "Updated successfully."
              : "Added successfully.",
        });

        if (editIndex !== null) {
          const updatedSections = [...savedSections];
          updatedSections[editIndex] = response.data;
          setSavedSections(updatedSections);
          setEditIndex(null);
        } else {
          setSavedSections((prevSections) => [...prevSections, response.data]);
        }
      } else {
        throw new Error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to process request.",
      });
    }

    setFormData({
      name: "",
      gmPercentage: "",
      agmPercentage: "",
      dmPercentage: "",
      doPercentage: "",
      moPercentage: "",
    });
    setErrors({});
  };

  const handleDelete = async (index) => {
    const sectionId = savedSections[index]?.id;

    try {
      const result = await Swal.fire({
        icon: "warning",
        title: "Are you Sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes! Delete it!",
      });

      if (result.isConfirmed) {
        await authAxios.delete(
          `${ADMIN_API_BASE_URL}/main/admin/delete-incentive/${sectionId}`
        );

        const updatedSections = savedSections.filter((_, i) => i !== index);
        setSavedSections(updatedSections);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Section has been deleted successfully.",
        });
      }
    } catch (error) {
      console.error("Error deleting section:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete section.",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEdit = (index) => {
    setFormData(savedSections[index]);
    setEditIndex(index);
  };

  return (
    <Base>
      <div
        className="pt-3 mt-5"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="none"
            key="2"
            color="inherit"
            href="/admin/admin_employee_percentage"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Employees Percentage
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">Employees Percentage</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "94%" }} />
      </div>

      <div className="container mt-3 d-flex justify-content-center align-items-center">
        <form
          className="p-4 border rounded shadow-sm bg-light w-100 emppercentage"
          onSubmit={handleSubmit}
        >
          {/* <h3 className="percentage_heading text-center mb-4">
            Employees Percentage
          </h3> */}

          {/* Section Name Input */}
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Section Name*
            </label>
            <input
              type="text"
              className="form-control"
              id="name"
              name="name"
              placeholder="Enter section name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </div>

          <div className="table-responsive">
            <table className="table table-borderless">
              <tbody>
                {/* General Manager (GM) */}
                <tr>
                  <td className="text-end align-middle custom-label">
                    <label htmlFor="gmPercentage">General Manager (GM)*:</label>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id="gmPercentage"
                      name="gmPercentage"
                      placeholder="(GM)"
                      value={formData.gmPercentage}
                      onChange={handleChange}
                    />
                    {errors.gmPercentage && (
                      <small className="text-danger">
                        {errors.gmPercentage}
                      </small>
                    )}
                  </td>
                </tr>

                {/* Assistant General Manager (AGM) */}
                <tr>
                  <td className="text-end align-middle custom-label">
                    <label htmlFor="agmPercentage">
                      Assistant General Manager (AGM)*:
                    </label>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id="agmPercentage"
                      name="agmPercentage"
                      placeholder="(AGM)"
                      value={formData.agmPercentage}
                      onChange={handleChange}
                    />
                    {errors.agmPercentage && (
                      <small className="text-danger">
                        {errors.agmPercentage}
                      </small>
                    )}
                  </td>
                </tr>

                {/* Development Manager (DM) */}
                <tr>
                  <td className="text-end align-middle custom-label">
                    <label htmlFor="dmPercentage">
                      Development Manager (DM)*:
                    </label>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id="dmPercentage"
                      name="dmPercentage"
                      placeholder="(DM)"
                      value={formData.dmPercentage}
                      onChange={handleChange}
                    />
                    {errors.dmPercentage && (
                      <small className="text-danger">
                        {errors.dmPercentage}
                      </small>
                    )}
                  </td>
                </tr>

                {/* Development Officer (DO) */}
                <tr>
                  <td className="text-end align-middle custom-label">
                    <label htmlFor="doPercentage">
                      Development Officer (DO)*:
                    </label>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id="doPercentage"
                      name="doPercentage"
                      placeholder="(DO)"
                      value={formData.doPercentage}
                      onChange={handleChange}
                    />
                    {errors.doPercentage && (
                      <small className="text-danger">
                        {errors.doPercentage}
                      </small>
                    )}
                  </td>
                </tr>

                {/* Marketing Officer (MO) */}
                <tr>
                  <td className="text-end align-middle custom-label">
                    <label htmlFor="moPercentage">
                      Marketing Officer (MO)*:
                    </label>
                  </td>
                  <td>
                    <input
                      type="number"
                      className="form-control"
                      id="moPercentage"
                      name="moPercentage"
                      placeholder="(MO)"
                      value={formData.moPercentage}
                      onChange={handleChange}
                    />
                    {errors.moPercentage && (
                      <small className="text-danger">
                        {errors.moPercentage}
                      </small>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-center mt-4">
            <button type="submit" className="custom-btn-percentage">
              {editIndex !== null ? "Update Section" : "Submit"}
            </button>
          </div>
        </form>
      </div>

      {/* Display Saved Sections */}

      <div className="container mt-4">
        <h3 className="text-center mb-4 percentage_save">Saved Sections</h3>
        {savedSections.length > 0 ? (
          <div className="row">
            {savedSections.map((section, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-3">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <strong>{section.name}</strong>
                    <div>
                      <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => handleEdit(index)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(index)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <p>
                      <strong>GM:</strong> {section.gmPercentage}
                    </p>
                    <p>
                      <strong>AGM:</strong> {section.agmPercentage}
                    </p>
                    <p>
                      <strong>DM:</strong> {section.dmPercentage}
                    </p>
                    <p>
                      <strong>DO:</strong> {section.doPercentage}
                    </p>
                    <p>
                      <strong>MO:</strong> {section.moPercentage}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No sections saved yet.</p>
        )}
      </div>
    </Base>
  );
};

export default Employeepercentage;
